<template>
	<div class="diagnosis-analyze">
		<h3 class="diagnosis-title">
			诊断分析
			<span class="refresh-time">刷新时间：{{ detail.refreshTime || '--' }}</span>
		</h3>
		<div class="content" v-if="!isAnalyzeDetails">
			<div class="large-card-list">
				<ul>
					<li
						v-for="(item, index) in diagnosisResults"
						:class="{ fail: item.error, empty: item.empty }"
						:key="index"
						@click="toAnalyzeDetail(item)"
					>
						<h5>{{ item.name }}</h5>
						<p>{{ item.value }}</p>
					</li>
				</ul>
			</div>
		</div>
		<div class="content" v-else>
			<div class="diagnosis-lengends">
				<div class="lengend" v-for="item in statusLengends" :key="item.name">
					<em :style="{ backgroundColor: item.color }"></em>
					<span>{{ item.name }}</span>
				</div>
			</div>
			<div class="analyze-details-cards">
				<ul v-if="detail[resultKey] && detail[resultKey].length">
					<li v-for="item in detail[resultKey]" :key="item.title" :class="{ fail: item.status === 2 }">
						<h5>{{ item.title }}</h5>
						<p>{{ item.message }}</p>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import { isArray } from '@/utils/validate'
import { diagnosisCardMenus, statusLengends } from './config'
export default {
	props: {
		// 是否是诊断分析详情卡片展示
		isAnalyzeDetails: {
			type: Boolean,
			default: false,
		},
		detail: {
			type: Object,
			default: () => {
				return {}
			},
		},
		resultKey: String,
	},
	data() {
		return {
			statusLengends,
		}
	},
	computed: {
		diagnosisResults() {
			return diagnosisCardMenus.map(item => {
				const msgs = this.detail[item.key]
				const value = isArray(msgs) ? msgs.join('、') : msgs
				const empty = !value && !!item.emptyText
				return {
					...item,
					value: empty ? item.emptyText : value,
					empty,
					error: item.statusKey ? (this.detail[item.statusKey] || []).some(m => m.status === 2) : false,
				}
			})
		},
	},
	methods: {
		toAnalyzeDetail(rowItem) {
			const { deviceId } = this.detail
			this.$router.push({
				name: 'diagnosisAnalyzeDetails',
				query: {
					deviceId,
				},
				params: {
					analyzeTabIdx: rowItem.analyzeTabIdx,
				},
			})
		},
	},
}
</script>
<style lang="scss" scoped>
.diagnosis-analyze {
	padding: 20px 0 0;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	.content {
		display: flex;
		flex: 1;
		min-height: 0;
		flex-direction: column;
		.large-card-list {
			margin-top: 20px;
			flex: 1;
			ul {
				height: 100%;
				display: grid;
				grid-template-columns: 1fr 1fr;
				grid-template-rows: minmax(185px, 1fr);
				gap: 10px;
				li {
					display: flex;
					flex-direction: column;
					background-color: #f0f3fc;
					border-radius: 4px;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					&:hover {
						background-color: #e2e8fb;
					}
					&.fail {
						background-color: #e5662e1a;
						h5 {
							color: #e5662e;
						}
					}
					&.empty {
						h5 {
							color: #5f667d;
						}
						p {
							color: #999;
							text-align: center;
						}
					}
					h5 {
						color: #2b57e8;
						font-size: 20px;
						font-weight: 600;
						line-height: 34px;
					}
					p {
						max-width: 100%;
						padding: 0 20px;
						box-sizing: border-box;
						color: #5f667d;
						font-size: 14px;
						font-weight: 500;
						line-height: 24px;
						text-align: left;
						word-break: break-word;
					}
				}
			}
		}
		.analyze-details-cards {
			ul {
				display: grid;
				grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
				grid-template-rows: 88px;
				gap: 10px;
				li {
					background-color: #f0f3fc;
					border-radius: 4px;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
					padding: 8px;
					&.fail {
						background-color: #e5662e1a;
						h5 {
							color: #e5662e;
						}
					}
					h5 {
						color: #2b57e8;
						font-size: 18px;
						font-weight: 600;
						line-height: 1.5;
					}
					p {
						color: #5f667d;
						font-size: 14px;
						line-height: 1.5;
					}
				}
			}
		}
		@media (max-width: 1566px) {
			.large-card-list {
				ul {
					grid-template-rows: minmax(150px, 1fr);
					gap: 6px;
					li {
						h5 {
							font-size: 17px;
							line-height: 26px;
						}
						p {
							font-size: 12px;
							line-height: 22px;
						}
					}
				}
			}
		}
	}
}
</style>
